import { api } from './api';

const getStripeOrder = async filters => {
  try {
    const queryString = new URLSearchParams(filters).toString();
    const { data } = await api.get(`/stripeOrder?${queryString}`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export default {
  getStripeOrder
};
